import { useNavigate } from "react-router-dom";

const routerUtil: {
  navigate: ReturnType<typeof useNavigate> | null;
} = {
  navigate: null,
};

export default routerUtil;
